/*
 * From https://www.redblobgames.com/maps/terrain-from-noise/
 * Copyright 2022 Red Blob Games <redblobgames@gmail.com>
 * @license Apache-2.0 <https://www.apache.org/licenses/LICENSE-2.0.html>
 */
'use strict';

export default function makeRand(seed) {
    // https://en.wikipedia.org/wiki/Lehmer_random_number_generator
    return function() {
        const wrap = 0x7FFFFFFF;
        seed = seed * 48271 % wrap;
        return (seed - 1) / (wrap - 1);
    };
}
    
